Splide.defaults = {
  type   : 'loop',
}

// トップページ KVスライダー
const top_kv_list = document.getElementsByClassName('js-slider_top_kv');
for (var i = 0; i < top_kv_list.length; i++) {
  const top_kv = new Splide(top_kv_list[i], {
    arrows: false,
    pagination: false,
    speed: 1000,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
    breakpoints: {
      600: {
        speed: 800
      },
    },
  });
  top_kv.mount();
}

// カーケア&タイヤショップ スライダー
const care_slider_list = document.getElementsByClassName('js-slider_care');
for (var i = 0; i < care_slider_list.length; i++) {
  new Splide(care_slider_list[i], {
    arrows: false,
    pagination: false,
    drag: false,
    fixedWidth: '209px',
    autoScroll: {
      speed: .8,
      pauseOnHover: false,
    },
  }).mount(window.splide.Extensions);
}
